<template>
  <div class="card-box" :style="cardBoxStyles">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'CardBox',
  props: {
    padding: {
      type: String,
      default: '25px 25px'
    }
  },
  computed: {
    cardBoxStyles () {
      return {
        padding: `${this.padding}`
      }
    }

  }
}
</script>

<style lang="scss" scoped>
  .card-box {
    border-radius: 6px;
    background-color: $white;
    box-shadow: 0 2px 11px 0 rgba(30, 45, 114, 0.1);
    width: 288px;

    @media (min-width: 420px) {
      width: 340px;
    }

    @media (min-width: $screen-md) {
      width: 400px;
    }
  }
</style>
